import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAxios } from 'context/AxiosContextProvider';

import config from '../../config';

export default function useDeleteWhiteLabelOrganizationUserMutation(queryKey: QueryKey) {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => {
      return axios.delete(`${config.apiBaseUrl}/op/v1/wap-users/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
}
